exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width: 767px){.new-collection[data-v-52c0b2bc]{padding-top:0}}", ""]);

// exports
